import React from "react";
import { SingleCardPage } from "../components/SingleCardPage";
import { DoggoError } from "../assets";
import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { loadCatalog } from "../i18n";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

export default function notfound() {
  const { _ } = useLingui();
  return (
    <SingleCardPage
      title="Uh Oh ..."
      backgroundColor="saweria-purple.light"
      imageSrc={DoggoError}
      message={_(
        msg`Halaman yang anda tuju tidak dapat dihubungi. Cobalah beberapa saat lagi.`
      )}
    />
  );
}
